module.exports = __webpack_public_path__ + "static/icons/icon-map--argentina-f6a5c9aa25d9297c0d0d06286e8396b0.svg";